import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class ClassRoom extends MongoEntity {
  static override _class = 'ClassRoom';
  static override _collectionName = 'classrooms';

  /** The owning Teacher's `_id` (not the AdornisUser id) — see db/teacher.ts. */
  @Field(() => String)
  teacherID!: string;

  @Field(() => String)
  name!: string;

  /** Grade/level component of `name` (e.g. "9", "12", "Q1", "EF") — derived when the classroom is
   * created, kept alongside `name` so grade and course/letter can be reasoned about separately. */
  @Field(() => String)
  grade: Maybe<string>;

  /** Sub-class identifier component of `name`: a letter (e.g. "a", "b") or a course type (e.g. "LK",
   * "GK"). Absent when the class has no such distinction (e.g. a bare "Q1"). */
  @Field(() => String)
  suffix: Maybe<string>;

  /**
   * Canonical {@link Subject} key this classroom is taught in — a class is scoped by subject, not
   * just name: the same teacher's "9a" in math and "9a" in physics are two separate classrooms with
   * their own roster/join code, since a teacher can teach the same named group in several subjects
   * (and different named groups in the same subject). `Maybe` only to tolerate classrooms created
   * before this field existed; every new classroom (manual or agent-created) must set it.
   */
  @Field(() => String)
  subject: Maybe<string>;

  /** 6-char join code students type in to request membership; regenerable, see regenerate-classroom-code.ts. */
  @Field(() => String)
  code!: string;

  @Field(() => String)
  createdAt!: string;
}
